import React, { Component } from 'react';
import Translation from '../../../../common/translation/translation.component';
import { HistoryLayout } from '../../../../common/history/history-layout.component';
import ManageUserHistory from './manage-user-details-history';
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { manageUserHistoryActions } from '../../../../../store/external/manage-user/manage-user-history.reducer'
import { MODAL_CUSTOM_MESSAGE } from "../../../../../constants/external-constants";

class ManageUserHistoryComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIndex: "0",
            enableSearchBox: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        };     
    }

    displaySearchBox = (value) => {
        this.setState({ enableSearchBox: value })
    }

    getSelectedIndex(value) {  
        this.setState({ selectedIndex: value })
    }

    onClickExtract = () => {
        const { employeeId, extractUserHistoryLogs } = this.props;
        if (window.confirm(this.state.exportAlertMsg)) {
            extractUserHistoryLogs(employeeId);
        }
    }  
    render() {
        return (
            <>
                <Translation
                    getOnlyText={true}
                    onChangeTranslation={() => { }}
                    translationKey={"export_alert_message"} />

                <HistoryLayout
                    extractAction={this.onClickExtract}
                    displaySearchBox={this.displaySearchBox}
                    hideCustomColumn={this.props.hideCustomColumn}

                    isReadOnly={this.props.isReadOnly}
                    isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                    isReadAndWrite={this.props.isReadAndWrite} 
                    hideCustomColumn={true}
                >

                    <ManageUserHistory
                        employeeId={this.props.employeeId}
                        isColSearchShow={this.state.enableSearchBox}                       
                    />
                </HistoryLayout>
            </>
        );
    }
}



export default connect(
    state => {
        const { } = state;

        return {

        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, manageUserHistoryActions),
        dispatch
    )
)(ManageUserHistoryComponent);